import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Modal from '@cred/react-modal/analytics/Modal'
import Disclosure from '../../disclosure'

class ChildrenModals extends Component {
  static propTypes = {
    disclosure: PropTypes.object.isRequired,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  render() {
    const {disclosure} = this.props

    return disclosure.children.map(this.createChildModal.bind(this))
  }

  createChildModal(child) {
    const {actions, className} = this.props

    if (child.contentType === 'modal') {
      return (
        <Modal
          key={`child-disclosure-${child.slug}`}
          multi
          dismiss={true}
          name={`child-disclosure-${child.slug}`}
          title={child.name}
        >
          <div className={`${className} ${`modal-${child.slug.replace(/\./g, '-')}`}`}>
            <Disclosure slug={child.slug} actions={actions}/>
          </div>
        </Modal>
      )
    } else {
      return ''
    }
  }
}

export default ChildrenModals
